//@ts-check
import isFile from './isFile';
/**
 * @type {import("./types").isFolderType}
 */

export default (function (path) {
  return !isFile(path);
});